import { string, bool, func, object } from 'prop-types';

export const searchInputProps = {
  label: string.isRequired,
  onSearchClick: func.isRequired,
  invalidError: string.isRequired,
  searchLabel: string.isRequired,
  initialValue: string,
  customError: string,
};

export const loyaltyPointSearchProps = {
  ...searchInputProps,
  title: string.isRequired,
  subtitle: string.isRequired,
  disabled: bool,
  customError: string,
  wrapperStyle: object,
  noteMsg: string,
};

export const bigPointNoteProps = {
  noteMsg: string,
};
